var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B1181",
    fillRule: "evenodd",
    d: "M12 6c-3.233 0-6.04 2.31-7.795 5.796l-.068.136a1.853 1.853 0 0 0-.032.068l.032.068.068.136C5.96 15.69 8.767 18 12 18c3.233 0 6.04-2.31 7.795-5.796a14.863 14.863 0 0 0 .1-.204 14.863 14.863 0 0 0-.1-.204C18.041 8.31 15.233 6 12 6ZM2.42 10.896C4.359 7.044 7.719 4 12 4c4.28 0 7.642 3.044 9.582 6.896l.021.043c.092.18.21.412.262.7a2.1 2.1 0 0 1 0 .723c-.052.287-.17.52-.262.7l-.021.042C19.642 16.956 16.28 20 12 20c-4.28 0-7.642-3.044-9.581-6.896l-.022-.043c-.091-.18-.21-.412-.262-.7a2.098 2.098 0 0 1 0-.723c.053-.287.17-.519.262-.7l.022-.042ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/ShowPassword.b6f1f421debaf6e6f7583c4650f6a674.svg";
export { ForwardRef as ReactComponent };